module.exports = __webpack_public_path__ + "img/searchList.c4580e83.svg";